import {
  cloneDeep,
  isArray,
  map,
  mapKeys,
  mapValues,
  isPlainObject,
  camelCase,
  snakeCase,
} from 'lodash';

// based on https://gist.github.com/emcmanus/eb735299788c820b4eb85c38f02598e4/revisions

function conversionFactory(conversionFn) {
  const keysToDifferentCasing = object => {
    if (typeof object !== 'object' || object === null) {
      return object;
    }

    let newObject = cloneDeep(object);

    if (isArray(newObject)) {
      return map(newObject, keysToDifferentCasing);
    }
    newObject = mapKeys(newObject, conversionFn);

    // Recursively apply throughout object
    return mapValues(newObject, value => {
      if (isPlainObject(value)) {
        return keysToDifferentCasing(value);
      }
      if (isArray(value)) {
        return map(value, keysToDifferentCasing);
      }
      return value;
    });
  };

  return keysToDifferentCasing;
}

export const snakeToCamelCase = conversionFactory((value, key) =>
  camelCase(key),
);

export const camelToSnakeCase = conversionFactory(
  // skips strings that already contain underscores
  (value, key) => (key.indexOf('_') === -1 ? snakeCase(key) : key),
);

export const toTitleCase = s =>
  s
    ? s
        .replace(/([A-Z])/g, match => ` ${match}`)
        .replace(/^./, match => match.toUpperCase())
    : s;
